import { FC } from 'react';
import { Button as MuiButton, styled } from '@mui/material';
import { BUTTON_COLORS, ButtonColorType } from '@utils/constants/color';

interface CommonButtonProps {
  variant?: ButtonColorType;
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
}

interface StyledButtonProps {
  colorVariant: ButtonColorType;
}

const StyledButton = styled(MuiButton)<StyledButtonProps>(({
  colorVariant,
}) => {
  const colors = BUTTON_COLORS[colorVariant];

  return {
    textTransform: 'none',
    fontWeight: 500,
    borderRadius: '4px',
    padding: '8px 16px',
    backgroundColor: colors.default.background,
    color: colors.default.text,
    border: `1px solid ${colors.default.border}`,
    '&:hover': {
      backgroundColor: colors.hover.background,
      color: colors.hover.text,
      border: `1px solid ${colors.hover.border}`,
    },
    '&.Mui-disabled': {
      opacity: 0.5,
      backgroundColor: colors.default.background,
      color: colors.default.text,
    },
  };
});

const CommonButton: FC<CommonButtonProps> = ({
  variant = 'primary',
  children,
  onClick,
  disabled = false,
  fullWidth = false,
  size = 'medium',
  startIcon,
  endIcon,
  type = 'button',
}) => {
  return (
    <StyledButton
      colorVariant={variant}
      onClick={onClick}
      disabled={disabled}
      fullWidth={fullWidth}
      size={size}
      startIcon={startIcon}
      endIcon={endIcon}
      type={type}
    >
      {children}
    </StyledButton>
  );
};

export default CommonButton;
